/**
 * functions common vue
 *
 * @category   Javascript
 * @author     Jakob Ohlsen <jakob.ohlsen@gmail.com>
 * @copyright  2025 Jakob Ohlsen
 */
import { ___, getLocale, toFixedNumberStr, toNumberStr } from '@ts/common/language';
import { formatDate, secToHhmmss } from '@ts/common/time';
import { defineAsyncComponent } from 'vue';
import {} from 'vue';
export function globalVueProperties() {
    return {
        ___: ___,
        getLocale: getLocale,
        secToHhmmss: secToHhmmss,
        formatDate: formatDate,
        toFixedNumberStr: toFixedNumberStr,
        toNumberStr: toNumberStr,
    };
}
export function registerComponents(app) {
    app.component('Anthropometry', defineAsyncComponent(() => import('@ts/components/analysis/Anthropometry.vue')));
    app.component('CarbohydrateManager', defineAsyncComponent(() => import('@ts/components/analysis/CarbohydrateManager.vue')));
    app.component('ChartLactate', defineAsyncComponent(() => import('@ts/components/analysis/ChartLactate.vue')));
    app.component('ChartMetabolism', defineAsyncComponent(() => import('@ts/components/analysis/ChartMetabolism.vue')));
    app.component('ChartReference', defineAsyncComponent(() => import('@ts/components/analysis/ChartReference.vue')));
    app.component('CompareAnthropometry', defineAsyncComponent(() => import('@ts/components/analysis/CompareAnthropometry.vue')));
    app.component('CompareChartLactate', defineAsyncComponent(() => import('@ts/components/analysis/CompareChartLactate.vue')));
    app.component('CompareChartMetabolism', defineAsyncComponent(() => import('@ts/components/analysis/CompareChartMetabolism.vue')));
    app.component('CompareFat', defineAsyncComponent(() => import('@ts/components/analysis/CompareFat.vue')));
    app.component('CompareLactate', defineAsyncComponent(() => import('@ts/components/analysis/CompareLactate.vue')));
    app.component('CompareOxygen', defineAsyncComponent(() => import('@ts/components/analysis/CompareOxygen.vue')));
    app.component('CompareThreshold', defineAsyncComponent(() => import('@ts/components/analysis/CompareThreshold.vue')));
    app.component('Fat', defineAsyncComponent(() => import('@ts/components/analysis/Fat.vue')));
    app.component('Lactate', defineAsyncComponent(() => import('@ts/components/analysis/Lactate.vue')));
    app.component('Oxygen', defineAsyncComponent(() => import('@ts/components/analysis/Oxygen.vue')));
    app.component('PotentialManager', defineAsyncComponent(() => import('@ts/components/analysis/PotentialManager.vue')));
    app.component('Threshold', defineAsyncComponent(() => import('@ts/components/analysis/Threshold.vue')));
    app.component('Zones', defineAsyncComponent(() => import('@ts/components/analysis/Zones.vue')));
}
